import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@components/_mui/Typography'

import useEffectState from '@shared/hooks/src/useEffectState'
import { TaskStatus, taskStatusToLabel } from '@shared/utils'

import { hiddenOutlineInput } from '@utils/StylesHelper'

import { useStatusUpdate } from '../Kanban.hooks'
import { useStatusChangeConfirmation } from './useStatusChangeConfirmation'

export default function SelectStatus({ task, disabled = false, canExpire = false, canComplete = false }) {
  const [status, setStatus] = useEffectState(task.status)

  const updateStatus = useStatusUpdate()
  const requestStatusChange = useStatusChangeConfirmation()

  const resetStatus = () => setStatus(task.status)

  const handleBlur = () => {
    if (status === task.status) return
    requestStatusChange(task, status, {
      onConfirm: (reason) => updateStatus.mutate({ id: task.id, newStatus: status, oldStatus: task.status, reason }),
      onCancel: resetStatus,
    })
  }

  if (disabled) {
    return <Typography>{taskStatusToLabel[task.status]}</Typography>
  }

  return (
    <TextField
      key={task.status}
      select
      fullWidth
      id="status"
      name="status"
      size="small"
      variant="outlined"
      value={status}
      onChange={(e) => setStatus(e.target.value)}
      onBlur={handleBlur}
      sx={[{ ml: -1 }, hiddenOutlineInput]}
      slotProps={{
        select: { IconComponent: () => null },
      }}
    >
      <MenuItem value={TaskStatus.ToDo}>
        <Typography>To Do</Typography>
      </MenuItem>
      <MenuItem value={TaskStatus.InProgress}>
        <Typography>In Progress</Typography>
      </MenuItem>
      <MenuItem value={TaskStatus.Waiting}>
        <Typography>Waiting</Typography>
      </MenuItem>
      {canComplete && (
        <MenuItem value={TaskStatus.Completed}>
          <Typography>Done</Typography>
        </MenuItem>
      )}
      {canExpire && (
        <MenuItem value={TaskStatus.Expired}>
          <Typography>Expired</Typography>
        </MenuItem>
      )}
    </TextField>
  )
}
